import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonReducerStoreService {
  public commonData: Observable<any>;

  constructor(private store: Store<any>) {
    this.commonData = store.select('commonReducer');
  }

  loadDetails(common: any) {
    this.store.dispatch({ type: 'LOAD_COMMON_DATA', payload: common });
  }
}
